import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
declare var toastr: any;
import swal from 'sweetalert';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UntypedFormGroup } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class FuncionesService {

  constructor(
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) { }

  /*MOSTRAR LOADING*/
  showLoading() {
    this.spinner.show();
  }
  /*OCULTAR LOADING*/
  hideLoading() {
    this.spinner.hide();
    return this;
  }

  validarInput(event: any) {
    var valorInput = event.value;

    var regex = /^[A-Za-z0-9.]*$/;

    if (!regex.test(valorInput)) {
        event.value = valorInput.replace(/[^A-Za-z0-9.]/g, '');
    } else {

    }
  }

  formatearFecha(fecha: string): string {
    return fecha
      .replace('T', ' ')
      .replace(/-/g, '/')
      .replace('/', '-')
      .replace('/', '-')
      .substr(0, 10);
  }

  primerDiaMes() {
    const date = new Date();
    const primerDia = new Date(date.getFullYear(), date.getMonth() + 1, 1);
    const mes = ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1);
    const dia = (primerDia.getDate() < 10 ? '0' : '') + primerDia.getDate();
    return date.getFullYear() + '-' + mes + '-' + dia;
  }

  ultimoDiaMes() {
    const date = new Date();
    const ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const mes = ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1);
    const dia = (ultimoDia.getDate() < 10 ? '0' : '') + ultimoDia.getDate();
    return date.getFullYear() + '-' + mes + '-' + dia;
  }

  generarHoraActual(fecha: Date) {
    const hora = fecha.getHours();
    const minuto = fecha.getMinutes();
    return (hora < 10 ? '0' + hora : hora) + ':' + (minuto < 10 ? '0' + minuto : minuto);
  }

  generarFechaLocal(fecha: Date) {
    const year = fecha.getFullYear();
    const month = (fecha.getMonth() + 1) < 10 ? '0' + (fecha.getMonth() + 1) : fecha.getMonth() + 1;
    const day = (fecha.getDate() < 10 ? '0' + (fecha.getDate()) : (fecha.getDate()));

    return year + '-' + month + '-' + day;
  }

  generarFechaLocal2(fecha: string) {
    const year = fecha.split('-')[0];
    const month = fecha.split('-')[1];
    const day = fecha.indexOf('T') == -1 ? fecha.split('-')[2].split(' ')[0] : fecha.split('-')[2].split('T')[0];

    return day + '/' + month + '/' + year;
  }

  generarFechaLocal3(fecha: string) {
    const year = fecha.split('-')[0];
    const month = fecha.split('-')[1];
    const day = fecha.indexOf('T') == -1 ? fecha.split('-')[2].split(' ')[0] : fecha.split('-')[2].split('T')[0];

    return month + '/' + year;
  }

  formatoFecha(fecha: NgbDate): any{
    if(fecha !== null){
      return fecha.day + '/' + (fecha.month < 10 ? '0' + fecha.month : fecha.month) + '/' + fecha.year;
    }else{
      return '';
    }
  }

  formatoFecha2(fecha: NgbDate): any{
    if(fecha !== null){
      return fecha.year + '-' + (fecha.month < 10 ? '0' + fecha.month : fecha.month) + '-' + fecha.day;
    }else{
      return '';
    }
  }

  formatearFecha4(fecha: string): string {
    const fechas = fecha.split('T')[0];
    return fechas;
  }


  b64toBlob(b64Data: any, contentType?: any, sliceSize?: any) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  base64ToArrayBuffer(base64: any) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
       var ascii = binaryString.charCodeAt(i);
       bytes[i] = ascii;
    }
    return bytes;
 }

  mensajeConfirmar(title: string, text: string, callBackOk?: any, callBackError?: any) {
    Swal.fire({
      title,
      html: text,
      icon: 'question',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCancelButton: true,
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar',
      reverseButtons: true
    }).then((resultado) => {
      if (resultado.value) {
        if (callBackOk) {
          callBackOk(resultado);
        }
      } else
        if (callBackError) {
          callBackError();
        }
    });
  }

  mensajeInput(text: string, callBackOk?: any) {
    const input: any = "input";
    swal(text, {
      content: input,
    })
    .then((resultado) => {
      callBackOk(resultado);
    });
  }

  showSuccess(message: string) {
    this.toastr.success('', message);
  }

  showWarning(message: string) {
    this.toastr.warning('', message);
  }

  showError(message: string) {
    this.toastr.error('', message);
  }

  showInfo(message: string) {
    this.toastr.info('', message);
  }

  /* ELIMINAR ELEMENTOS */
  removeItemFromArr(arr: any, item: any ) {
    const i = arr.indexOf( item );
    arr.splice( i, 1 );
  }

  removeDuplicates(originalArray: any, prop: any) {
    const newArray = [];
    const lookupObject  = {};

    // tslint:disable-next-line:forin
    for (const i in originalArray) {
       lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    // tslint:disable-next-line:forin
    for (const i in lookupObject) {
        newArray.push(lookupObject[i]);
    }
    return newArray;
  }

  maxLength: number = 8;

  validarTipoDOcumento(event: any){
    if (event.value !== null) {
      if (parseInt(event.value) === 1) {
        this.maxLength = 8;
      }else{
        this.maxLength = 20;
      }
    }
    else{
      this.maxLength = 20;
    }
  }

  validarFecha(){
    let fecha: Date = new Date();
    return (fecha.getFullYear()) + '-' + (fecha.getMonth() < 10 ? '0' + (fecha.getMonth() + 1) : (fecha.getMonth() + 1)) + '-' + (fecha.getDate() < 10 ? '0' + fecha.getDate() : fecha.getDate());
  }

  soloAceptarLetras(target: any){
    target.value = target.value.replace(/[^a-zA-Z]+/g, '');
  }

  /*INPUT SOLO NUMEROS*/
  soloAceptarNumeros(target: any) {
    target.value = target.value.replace(/[^0-9]+/g, '');
  }

  /*INPUT SOLO NUMEROS CON PUNTO DECIMAL*/
  soloAceptarNumerosPuntoDecimal(target: any) {
    target.value = target.value.replace(/[^0-9.]/g, '');
  }

  validaDNI(dni: any) {
    // tslint:disable-next-line:variable-name
    let ex_regular_dni: RegExp;
    ex_regular_dni = /^\d{8}(?:[-\s]\d{4})?$/;
    if (ex_regular_dni.test (dni) === true) {
      return true;
    } else {
      return false;
    }
  }

  validarCorreo(email: string | any){
    const caract = new RegExp(/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/);
    let retornar: boolean = false;

    if (caract.test(email) === true){
        retornar = true;
    }else{
      retornar = false;
    }

    return retornar;
  }

  convertStringToNumber(input: any) {
    if(input.length !== undefined){
      if (input.trim().length==0) {
          return NaN;
      }
    }
    return Number(input);
  }

  meses(value: string | undefined): any {

    let mesLetra: string;

    switch (value) {
      case '12':
        mesLetra = 'DICIEMBRE';
        break;
      case '11':
        mesLetra = 'NOVIEMBRE';
        break;
      case '10':
        mesLetra = 'OCTUBRE';
        break;
      case '09':
        mesLetra = 'SETIEMBRE';
        break;
      case '08':
        mesLetra = 'AGOSTO';
        break;
      case '07':
        mesLetra = 'JULIO';
        break;
      case '06':
        mesLetra = 'JUNIO';
        break;
      case '05':
        mesLetra = 'MAYO';
        break;
      case '04':
        mesLetra = 'ABRIL';
        break;
      case '03':
        mesLetra = 'MARZO';
        break;
      case '02':
        mesLetra = 'FEBRERO';
        break;
      case '01':
        mesLetra = 'ENERO';
        break;
      default:
        mesLetra = '';
        break;
    }

    return mesLetra;
  }
}

export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: UntypedFormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
          // return if another validator has already found an error on the matchingControl
          return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
          matchingControl.setErrors({ mustMatch: true });
      } else {
          matchingControl.setErrors(null);
      }
  }
}
